import { useEffect, useState } from 'react';
import getConfig from 'next/config';
import { Template, FetchState } from '../../components/types';
import { fetchTemplates } from '../../utils/resources-utils';
import { Vertical } from '../../consts/verticalContents';

const getVerticalInflections = (vertical) => {
  switch (vertical) {
    case Vertical.SPORT:
    case Vertical.SPORTS:
      return `${Vertical.SPORT}-${Vertical.SPORTS}`;
    case Vertical.TECH:
    case Vertical.TECHNOLOGY:
      return `${Vertical.TECH}-${Vertical.TECHNOLOGY}`;
    case Vertical.COMMERCE:
    case Vertical.E_COMMERCE:
      return Vertical.COMMERCE;
    default:
      return vertical;
  }
};

// To increase the chances of receiving data from the server we should connect all vertical inflections into a string.
const enrichVertical = (vertical) => (
  vertical === Vertical.ALL ? '' : vertical
    .split('-')
    .map((v) => getVerticalInflections(v) || v)
    .join('-')
);

const initialState: FetchState<Template[]> = {
  data: null,
  loading: true,
  error: null,
};

const useTemplates: (vertical) => FetchState<Template[]> = (vertical) => {
  const [response, setResponse] = useState<FetchState<Template[]>>({ ...initialState });
  const { publicRuntimeConfig: { config } } = getConfig();
  const { STATIC_PUBLIC_URL } = config;

  useEffect(() => {
    if (!vertical) {
      return;
    }

    // Reset loading state when starting a new fetch
    setResponse((prev) => ({ ...prev, loading: true, error: null }));

    fetchTemplates(enrichVertical(vertical))
      .then((payload) => setResponse((pre) => ({
        ...pre,
        loading: false,
        data: payload
          .map(({ thumb, ...rest }) => ({
            ...rest, thumb: { ...thumb, path: `${STATIC_PUBLIC_URL}/${thumb.path}` },
          })),
      })))
      .catch((error) => setResponse((pre) => ({ ...pre, loading: false, error })));
  }, [vertical]);

  return response;
};

export default useTemplates;
